'use strict';

angular.module('imagetrend.components')
    .controller('InspectionSpotCheckModalController', ['$scope', '$uibModalInstance', 'Services', 'IPVisits', function ($scope, $uibModalInstance, Services, IPVisits) {
        $scope.spotCheckInfo = {
            vehicle: {},
            service: {}
        };
        $scope.new_vehicle = false;
        $scope.services = [];
        $scope.selectParameter = 'Service';
        $scope.close = function () {
            $uibModalInstance.close(false);
        }

        $scope.addVehicle = function (vehicle) {
            if (vehicle != null) {
                $scope.spotCheckInfo.vehicle = vehicle;
                Services.getServicesFromVehicleId(vehicle.id).then(function (services) {
                    $scope.services = services;

                    if (services.length === 1) {
                        $scope.services[0].is_default = true;
                        $scope.spotCheckInfo.service = $scope.services[0];
                    }
                });

                vehicle = null;
                $scope.new_vehicle = false;
            }
        }

        $scope.removeVehicle = function () {
            $scope.spotCheckInfo.vehicle = {};
            $scope.spotCheckInfo.service = {};
            $scope.services = [];
        }

        $scope.addService = function (serviceId) {
            if (serviceId != null) {
                var idx = $scope.services.findIndex(function (item) {
                    return item.id === serviceId;
                });
                $scope.spotCheckInfo.service = $scope.services[idx];
            } else {
                $scope.spotCheckInfo.service = {};
            }
        }

        $scope.postSpotCheckInspection = function () {
            IPVisits.postSpotCheckInspection($scope.spotCheckInfo).then(function (ret) {
                $uibModalInstance.close(ret);
            });
        }
    }])
    ;